module.exports = {
    DOWN: 40,
    LEFT: 37,
    RIGHT: 39,
    UP: 38,
};
